import { gql } from 'graphql-tag';

export const tnProvisionFormSettingsFields = `
  account
  trunkId
  voiceServiceId
  domain
  sms
  mms
  campaignId
  noToken
  errorValidating
  invalidToken
  cnamDipping
  reputationScore
  warningScore
  warningAction
  alarmingScore
  alarmingAction
  callForwarding
  forwardingNumber
  cnamCallerId
  portOutPin
  subscription {
    trunkName
    sansayId
    dstId
    serviceProviderId
    product
    subscriberRatePlan
  }
`;

const serviceTypeFields = `
  type
  name
  position
  category
  flags
  scope
  regions
  defaultSettings {
    tnProvisionFormSettings {
      ${tnProvisionFormSettingsFields}
    }
  }
`;

export const platformServiceSummaryFields = `
  id
  type
  typeName
  category
  typeFlags
  displayName
  name
  customerId
  accountId
  accountName
  accountNumber
  status
  statusMessage
  rootPath
  createdAt
  updatedAt
`;

export const platformServiceFields = `
  ${platformServiceSummaryFields}
  settings {
    serviceSettings {
      ... on NusoSipSettings {
        pbxNumber
        maxCallPaths
        e911Type
      }
      ... on CloudUcSettings {
        businessGroup
        totalInternalLines

        recordingServer
      }
      ... on BlueSipSettings {
        userId
        maxCallPaths
        e911Type
      }
      ... on GreenUcSettings {
        domain
        greenResellerServiceId

        countryCode
        areaCode
        callerIdNumber
        callerIdNumberEmergency
        callerIdName

        # Advanced NetSapiens Settings
        recordingConfiguration
        domainType
        singleSignOnEnabled
        dialPolicy
        musicOnHoldRandomizedEnabled
        voicemailUserControlEnabled
        voicemailTranscriptionEnabled
        netsapiensDomainConfig {
          domain
          domainType
          dialPolicy
          singleSignOnEnabled
          recordingConfiguration
          musicOnHoldRandomizedEnabled
          voicemailUserControlEnabled
          voicemailTranscriptionEnabled
        }

      }
      ... on IpFaxSettings {
        pbxId
        location
      }
      ... on CcaasSettings {
        tenantId
        voiceServiceId
        name
      }
      ... on BridgeZoomSettings {
        tenantIdString: tenantId
        bridgeZoomResellerServiceId
        allocatedProduct
      }
      ... on TeamsSipSettings {
        tenantIdString: tenantId
        # name
        resellerId
        enterpriseId
        primarySbc
        adminEmail
        bridgeRegion
        trunkName
        sansayId
        consents {
          name
          status
        }
      }
      ... on TeamsPcSettings {
        tenantIdString: tenantId
        resellerId
        enterpriseId
        primarySbc
        adminEmail
        bridgeRegion
        consents {
          name
          status
        }
      }
      ... on TeamsOcSettings {
        tenantIdString: tenantId
      }
      ... on TeamsAdSettings {
        tenantIdString: tenantId
      }
      ... on CarrierTrunkSettings {
        trunkType
        trunkName
        sansayId
        rampId
        trunkId
      }
      ... on CarrierTenantTrunkSettings {
        trunkServiceId
        trunkType
        trunkName
        sansayId
        rampId
        trunkId
      }
      ... on GreenResellerSettings {
        reseller
        trunkName
        trunkIdString: trunkId
      }
      ... on BridgeZoomResellerSettings {
        trunkName
        trunkIdString: trunkId
      }
      ... on TeamsResellerSettings {
        trunkName
        trunkIdString: trunkId
      }
      ... on WorkflowDemoSettings {
        demoMode
        simulatedDelay
        step1Delay
        step2Delay
        step3Delay
        setupSimulationTime
      }
      ... on TeamsDomainSettings {
        tenantIdString: tenantId
        globalAdminEmail
        authorizationDraft {
          agreed
          enabledApps
        }
      }
      ... on ZoomDomainSettings {
        tenantIdString: tenantId
        globalAdminEmail
        authorizationDraft {
          agreed
          enabledApps
        }
      }
      ... on AiServicesSettings {
        pbxNumber
        maxCallPaths
        e911Type
      }
    }
    tnProvisionFormSettings {
      ${tnProvisionFormSettingsFields}
    }
  }
`;

export const customerPlatformServiceSummaryFields = `
  id
  hasActiveRecordingService
`;


export const platformServiceReportFields = `
  id
  title
  description
  serviceType
  createdBy
  changedBy
  createdOnDeltaHumanized
  changedOnDeltaHumanized
  roleNames
  ownerNames
  thumbnailUrl
  url
`;

export const platformServiceReportDetailFields = `
  ${platformServiceReportFields}
  embedId
  embedToken
  embedDomain
`;

export const serviceTypesQuery = gql`
  query serviceTypes {
    serviceTypes {
      ${serviceTypeFields}
    }
  }
`;

export const customerAvailableServiceTypesAndAssociatedServicesQuery = gql`
  query customerAvailableServiceTypesAndAssociatedServices {
    customerAvailableServiceTypesAndAssociatedServices {
      serviceTypes {
        ${serviceTypeFields}
      }
      associatedServices {
        ${platformServiceSummaryFields}
        settings {
          serviceSettings {
            ... on NusoSipSettings {
              pbxNumber
              maxCallPaths
              e911Type
            }
            ... on CloudUcSettings {
              businessGroup
              totalInternalLines

              recordingServer
            }
            ... on BlueSipSettings {
              userId
              maxCallPaths
              e911Type
            }
            ... on GreenUcSettings {
              domain
              greenResellerServiceId
            }
            ... on IpFaxSettings {
              pbxId
              location
            }
            ... on CcaasSettings {
              tenantId
              voiceServiceId
              name
            }
            ... on BridgeZoomSettings {
              tenantIdString: tenantId
              bridgeZoomResellerServiceId
            }
            ... on TeamsSipSettings {
              tenantIdString: tenantId
              name
              resellerId
              enterpriseId
            }
            ... on TeamsPcSettings {
              tenantIdString: tenantId
              resellerId
              enterpriseId
            }
            ... on TeamsOcSettings {
              tenantIdString: tenantId
            }
            ... on TeamsAdSettings {
              tenantIdString: tenantId
            }
            ... on CarrierTrunkSettings {
              trunkType
              trunkName
              sansayId
              rampId
              trunkId
            }
            ... on CarrierTenantTrunkSettings {
              trunkServiceId
              trunkType
              trunkName
              sansayId
              rampId
              trunkId
            }
            ... on GreenResellerSettings {
              reseller
              trunkName
              trunkIdString: trunkId
            }
            ... on BridgeZoomResellerSettings {
              trunkName
              trunkIdString: trunkId
            }
            ... on TeamsResellerSettings {
              trunkName
              trunkIdString: trunkId
            }
            ... on AiServicesSettings {
              pbxNumber
              maxCallPaths
              e911Type
            }
          }
          tnProvisionFormSettings {
            ${tnProvisionFormSettingsFields}
          }
        }
      }
    }
  }
`;

export const getPlatformServiceQuery = gql`
  query getPlatformService($id: ID!) {
    getPlatformService(id: $id) {
      ${platformServiceFields}
      customer {
        ${customerPlatformServiceSummaryFields}
        platformServices {
          ${platformServiceSummaryFields}
        }
      }
    }
  }
`;

export const getPlatformServiceForFaxDeviceQuery = gql`
  query getPlatformServiceForFaxDevice($faxId: ID!) {
    getPlatformServiceForFaxDevice(faxId: $faxId) {
      ${platformServiceSummaryFields}
    }
  }
`

export const getCurrentUserPortalUserQuery = gql`
  query getCurrentUserPortalUser {
    getCurrentUserPortalUser {
      userId
      customerId
      platformServices {
        ${platformServiceSummaryFields}
      }
    }
  }
`;

export const updateServiceTypeMutation = gql`
  mutation updateServiceType($input: UpdateServiceTypeInput!) {
    updateServiceType(input: $input) {
      ${serviceTypeFields}
    }
  }
`;

export const createServiceTypeMutation = gql`
  mutation createServiceType($input: CreateServiceTypeInput!) {
    createServiceType(input: $input) {
      ${serviceTypeFields}
    }
  }
`;

export const createPlatformServiceMutation = gql`
  mutation createPlatformService($input: CreatePlatformServiceInput!) {
    createPlatformService(input: $input) {
      ${customerPlatformServiceSummaryFields}
      platformServices {
        ${platformServiceFields}
      }
    }
  }
`;

export const updatePlatformServiceMutation = gql`
  mutation updatePlatformService($input: UpdatePlatformServiceInput!) {
    updatePlatformService(input: $input) {
      ${platformServiceFields}
    }
  }
`;

export const updatePlatformServicNameMutation = gql`
  mutation updatePlatformServiceName($input: UpdatePlatformServiceNameInput!) {
    updatePlatformServiceName(input: $input) {
      ${platformServiceFields}
    }
  }
`;

export const deletePlatformServiceMutation = gql`
  mutation deletePlatformService($id: ID!) {
    deletePlatformService(id: $id) {
      ${platformServiceFields}
      customer {
        ${customerPlatformServiceSummaryFields}
      }
    }
  }
`;

export const deprovisionPlatformServiceMutation = gql`
  mutation deprovisionPlatformService($id: ID!) {
    deprovisionPlatformService(id: $id) {
      ${platformServiceFields}
      customer {
        ${customerPlatformServiceSummaryFields}
      }
    }
  }
`;

export const provisionPlatformServiceMutation = gql`
  mutation provisionPlatformService($id: ID!) {
    provisionPlatformService(id: $id) {
      ${platformServiceFields}
      customer {
        ${customerPlatformServiceSummaryFields}
      }
    }
  }
`;

export const provisionPlatformServiceAfterAuthorizationMutation = gql`
  mutation provisionPlatformServiceAfterAuthorization($id: ID!) {
    provisionPlatformServiceAfterAuthorization(id: $id) {
      ${platformServiceFields}
    }
  }
`;

export const setPlatformServiceEnabledStatusMutation = gql`
  mutation setPlatformServiceEnabledStatus($id: ID!, $enabled: Boolean!) {
    setPlatformServiceEnabledStatus(id: $id, enabled: $enabled) {
      ${platformServiceFields}
      customer {
        ${customerPlatformServiceSummaryFields}
      }
    }
  }
`;

export const updateServiceAdvancedSettingsMutation = gql`
  mutation updateServiceAdvancedSettings($input: UpdateServiceAdvancedSettingsInput!) {
    updateServiceAdvancedSettings(input: $input) {
      ${platformServiceFields}
    }
  }
`;

export const platformServiceReportsQuery = gql`
  query platformServiceReports($input: PlatformServiceReportsInput!) {
    platformServiceReports(input: $input) {
      ${platformServiceReportFields}
    }
  }
`;

export const getAuthorizationServicesQuery = gql`
  query getAuthorizationServices($input: GetAuthorizationServicesInput!) {
    getAuthorizationServices(input: $input) {
      totalCount
      services {
        ${platformServiceSummaryFields}
        settings {
          serviceSettings {
            ... on TeamsDomainSettings {
              authorizedConsents
              tenantId
              globalAdminEmail
              authorizationDraft {
                agreed
                enabledApps
              }
            }
            ... on ZoomDomainSettings {
              authorizedConsents
              tenantId
              globalAdminEmail
              authorizationDraft {
                agreed
                enabledApps
              }
            }
          }
        }
      }
    }
  }
`;

export const sendAuthorizationEmailMutation = gql`
  mutation sendAuthorizationEmail($input: SendAuthorizationEmailInput!) {
    sendAuthorizationEmail(input: $input) {
      success
      message
    }
  }
`;

export const platformServiceReportDetailsQuery = gql`
  query platformServiceEmbeddableReport($input: PlatformServiceEmbeddableReportInput!) {
    platformServiceEmbeddableReport(input: $input) {
      ${platformServiceReportDetailFields}
    }
  }
`;
